import * as React from 'react';

function PlusIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={12} height={12} fill="none" {...props}>
      <path
        d="M7 1.438v3.937h3.938a.9.9 0 01.874.875c0 .492-.41.875-.874.875H7v3.938c0 .492-.41.874-.875.874a.864.864 0 01-.875-.874V7.124H1.312a.864.864 0 01-.875-.875c0-.465.383-.875.875-.875H5.25V1.437c0-.464.383-.875.875-.875A.9.9 0 017 1.438z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoPlusIcon = React.memo(PlusIcon);
export default MemoPlusIcon;
